export const STORAGE_KEYS = {
  IMAGES: 'jb_motorcycles_gallery_images',
  ADMIN_STATE: 'jb_motorcycles_admin_state',
} as const;

export type BrandId = 'used' | 'honda' | 'hero' | 'sym' | 'kayo' | 'bajaj' | 'lifan' | 'other' | 'stripping';

export interface GalleryImage {
  id: string;
  brandId: BrandId;
  url: string;
  alt: string;
  isFeatured: boolean;
  sortOrder: number;
  rotation: number;
  createdAt: string;
  updatedAt: string;
}

export const BRANDS: { id: BrandId; label: string; color: string }[] = [
  { id: 'used', label: 'Used Motorbike Sales', color: 'gold' },
  { id: 'honda', label: 'Honda', color: 'red' },
  { id: 'hero', label: 'Hero', color: 'blue' },
  { id: 'sym', label: 'Sym', color: 'green' },
  { id: 'kayo', label: 'Kayo', color: 'orange' },
  { id: 'bajaj', label: 'Bajaj', color: 'purple' },
  { id: 'lifan', label: 'Lifan', color: 'pink' },
  { id: 'other', label: 'Other', color: 'gray' },
  { id: 'stripping', label: 'Stripping for Spares', color: 'amber' },
];

export const SITE_CONFIG = {
  name: 'JB Motorcycles',
  tagline: 'Premium Motorcycle Showroom',
  phone: {
    landline: '065 855 2935',
    mobile: '079 079 1158',
  },
  email: {
    sales: 'bothajohan49@gmail.com',
    admin: 'bothajohan49@gmail.com',
  },
  address: '825 Steve Biko Rd, Gezina, Pretoria, 0031',
  hours: {
    weekday: '8:00 - 17:00 Monday - Friday',
    saturday: '8:00 - 13:00 Saturday',
  },
  social: {
    facebook: 'https://www.facebook.com/jbmotorcycle/',
  },
  logo: '/images/logo.png',
} as const;

export const TOP_BAR_ITEMS = [
  { label: 'Spare Parts Sales', icon: 'Package', description: 'Wide variety of new & secondhand parts — service parts for major & Chinese brands' },
  { label: 'Workshop & Service Center', icon: 'Wrench', description: '20+ years experience — all bikes repaired with care' },
  { label: 'Other', icon: 'MoreHorizontal', description: 'Other motorcycle services & accessories' },
  { label: 'Stripping for Spares', icon: 'Wrench', description: 'Bike stripping & salvage for spare parts' },
] as const;

export const DEFAULT_IMAGES: GalleryImage[] = [
  {
    id: '1',
    brandId: 'used',
    url: 'https://images.unsplash.com/photo-1558981852-426c6c22aef1?w=800&h=600&fit=crop',
    alt: 'USED YAMAHA RAPTOR 90 - 2008 Model',
    isFeatured: true,
    sortOrder: 0,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '2',
    brandId: 'used',
    url: 'https://images.unsplash.com/photo-1568772779586-5f49b20e3e1a?w=800&h=600&fit=crop',
    alt: 'USED HONDA TRANSALP 750 - 2023 Model 7000km',
    isFeatured: true,
    sortOrder: 1,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '3',
    brandId: 'honda',
    url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
    alt: 'NEW HONDA CBR500R - 2024 Model ABS',
    isFeatured: true,
    sortOrder: 0,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '4',
    brandId: 'hero',
    url: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=800&h=600&fit=crop',
    alt: 'NEW HERO XTREME 160R - 2024 Model',
    isFeatured: true,
    sortOrder: 0,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '5',
    brandId: 'sym',
    url: 'https://images.unsplash.com/photo-1590438773020-27bf5f740e4d?w=800&h=600&fit=crop',
    alt: 'NEW SYM JET 14 125 - 2024 Model',
    isFeatured: true,
    sortOrder: 0,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '6',
    brandId: 'kayo',
    url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
    alt: 'NEW KAYO PREDATOR 125 - 2024 Dirt Bike',
    isFeatured: true,
    sortOrder: 0,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '7',
    brandId: 'bajaj',
    url: 'https://images.unsplash.com/photo-1568772779586-5f49b20e3e1a?w=800&h=600&fit=crop',
    alt: 'NEW BAJAJ PULSAR NS200 - 2024 ABS',
    isFeatured: true,
    sortOrder: 0,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '8',
    brandId: 'lifan',
    url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
    alt: 'NEW LIFAN KP MINI 150 - 2024 Retro Style',
    isFeatured: true,
    sortOrder: 0,
    rotation: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export function loadImages(): GalleryImage[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.IMAGES);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (e) {
    console.warn('Failed to load images from storage:', e);
  }
  localStorage.setItem(STORAGE_KEYS.IMAGES, JSON.stringify(DEFAULT_IMAGES));
  return DEFAULT_IMAGES;
}

export function saveImages(images: GalleryImage[]): void {
  try {
    localStorage.setItem(STORAGE_KEYS.IMAGES, JSON.stringify(images));
  } catch (e) {
    console.error('Failed to save images:', e);
  }
}

export function addImage(image: Omit<GalleryImage, 'id' | 'createdAt' | 'updatedAt'>): GalleryImage {
  const images = loadImages();
  const newImage: GalleryImage = {
    ...image,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  const updated = [...images, newImage].sort((a, b) => a.sortOrder - b.sortOrder);
  saveImages(updated);
  return newImage;
}

export function updateImage(updatedImage: GalleryImage): void {
  const images = loadImages();
  const updated = images.map((img) =>
    img.id === updatedImage.id ? { ...updatedImage, updatedAt: new Date().toISOString() } : img
  );
  saveImages(updated);
}

export function deleteImage(id: string): void {
  const images = loadImages();
  const filtered = images.filter((img) => img.id !== id);
  saveImages(filtered);
}

export function reorderImages(brandId: BrandId, orderedIds: string[]): void {
  const images = loadImages();
  const brandImages = images.filter((img) => img.brandId === brandId);
  const otherImages = images.filter((img) => img.brandId !== brandId);

  const reordered = orderedIds.map((id, index) => {
    const img = brandImages.find((b) => b.id === id);
    return img ? { ...img, sortOrder: index + 1, updatedAt: new Date().toISOString() } : null;
  }).filter(Boolean) as GalleryImage[];

  saveImages([...reordered, ...otherImages].sort((a, b) => a.sortOrder - b.sortOrder));
}

export function getImagesByBrand(brand: BrandId): GalleryImage[] {
  const images = loadImages();
  return images.filter((img) => img.brandId === brand).sort((a, b) => a.sortOrder - b.sortOrder);
}

export function getAdminState(): { isAdmin: boolean } {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.ADMIN_STATE);
    if (stored) return JSON.parse(stored);
  } catch (e) {
    console.warn('Failed to load admin state:', e);
  }
  return { isAdmin: false };
}

export function setAdminState(isAdmin: boolean): void {
  localStorage.setItem(STORAGE_KEYS.ADMIN_STATE, JSON.stringify({ isAdmin }));
}